const TouchType = {
  MOUSE: {
    UP: "mouseup",
    DOWN: "mousedown",
    MOVE: "mousemove",
  },
  TOUCH: {
    UP: "touchend",
    DOWN: "touchstart",
    MOVE: "touchmove",
  },
};

class Draggable {
  constructor(elementPicker, elementToDrag) {
    this.deviceType = "";
    this.elementPicker = elementPicker;
    this.elementToDrag = elementToDrag;
    this.moveElement = false;
    this.initialX = 0;
    this.initialY = 0;

    this.isTouchDevice();
    this.addEventListeners();
  }

  isTouchDevice() {
    try {
      // TouchEvent would fail for desktops and throw error
      document.createEvent("TouchEvent");
      this.deviceType = "TOUCH";
      return true;
    } catch (e) {
      this.deviceType = "MOUSE";
      return false;
    }
  }

  addEventListeners() {
    this.elementPicker.addEventListener(
      TouchType[this.deviceType].DOWN,
      this.onElementMouseDown
    );

    document.addEventListener(
      TouchType[this.deviceType].UP,
      this.onDocumentMouseUp
    );

    document.addEventListener(
      TouchType[this.deviceType].MOVE,
      this.onDocumentMouseMove
    );
  }

  onElementMouseDown = (e) => {
    const isNotTouchDevice = !this.isTouchDevice();
    this.initialX = isNotTouchDevice ? e.clientX : e.touches[0].clientX;
    this.initialY = isNotTouchDevice ? e.clientY : e.touches[0].clientY;

    document.getElementById("customization-overlay").classList.add("dragging");
    document.querySelector(".customizable-wizard").classList.add("dragging");
    this.moveElement = true;
  };

  onDocumentMouseUp = () => {
    if (this.moveElement) {
      this.moveElement = false;

      document
        .getElementById("customization-overlay")
        .classList.remove("dragging");
      document
        .querySelector(".customizable-wizard")
        .classList.remove("dragging");
    }
  };

  onDocumentMouseMove = (e) => {
    const elem = this.elementToDrag;
    if (this.moveElement) {
      const windowWidth = window.innerWidth;

      const isNotTouchDevice = !this.isTouchDevice();
      const newX = isNotTouchDevice ? e.clientX : e.touches[0].clientX;
      const newY = isNotTouchDevice ? e.clientY : e.touches[0].clientY;
      const left = elem.offsetLeft - (this.initialX - newX);
      const horizontalEdgeOffset = 40;
      const topEdgeOffset = 64;

      elem.style.left = `${left}px`;

      if (newX < windowWidth / 2) {
        elem.classList.remove("right");
        if (elem.offsetLeft < horizontalEdgeOffset) {
          elem.style.left = `${horizontalEdgeOffset}px`;
        }
      } else {
        elem.classList.add("right");
        if (left + elem.offsetWidth > windowWidth - horizontalEdgeOffset) {
          const left = windowWidth - elem.offsetWidth - horizontalEdgeOffset;
          elem.style.left = `${left}px`;
        }
      }

      if (elem.offsetTop < topEdgeOffset) {
        elem.style.top = `${topEdgeOffset}px`;
        elem.style.bottom = "auto";
      } else if (elem.offsetTop + elem.offsetHeight > window.innerHeight) {
        elem.style.top = "auto";
        elem.style.bottom = "0";
      } else {
        elem.style.top = `${elem.offsetTop - (this.initialY - newY)}px`;
        elem.style.bottom = "auto";
      }

      this.initialX = newX;
      this.initialY = newY;
    }
  };
}

export default Draggable;
